import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1) / 2,
    fontWeight: 500
  },
  award: {
    marginBottom: theme.spacing(3),
    color: theme.palette.secondary.main,
    fontWeight: 300,
  },
  finalist: {
    marginBottom: theme.spacing(2),
  },
  name: {
    marginBottom: theme.spacing(1) / 2,
  },
  credentials: {
    fontWeight: 300,
  },
}));

const DivisionOne = (props) => {
  const classes = useStyles();
  const division = props.config.divisions[0]
  return (
    <>
      <h2 className={classes.title}>{division.title}</h2>
      <Grid container direction="row" spacing={3}>
        {division.awards.map((award, index) => (
          <Grid item xs={12} md={6} key={index}>
            <h3 className={classes.award}>{award.title}</h3>
            <Grid container direction="row" spacing={0}>
              {award.finalists.map((finalist, index2) => (
                <Grid item xs={12} sm={6} key={index}>
                  <div className={classes.finalist} key={index2}>
                    <h4 className={classes.name}>{finalist.name}</h4>
                    <h5 className={classes.credentials}>{finalist.credentials}</h5>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

const DivisionMany = (props) => {
  const classes = useStyles();
  return (
    <Grid container direction="row" spacing={3}>
      {props.config.divisions.map((division) => (
        <Grid item xs={12} md={6} key={division.id}>
          <h2 className={classes.title}>{division.title}</h2>
          <Grid container direction="row" spacing={3}>
            {division.awards.map((award, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <h3 className={classes.award} style={{ maxWidth: '150px' }}>{award.title}</h3>
                {award.finalists.map((finalist, index2) => (
                  <div className={classes.finalist} key={index2}>
                    <h4 className={classes.name}>{finalist.name}</h4>
                    <h5 className={classes.credentials}>{finalist.credentials}</h5>
                  </div>
                ))}
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};


export default (props) => {
  return (props.config.divisions.length === 1 ? <DivisionOne config={props.config} /> : <DivisionMany config={props.config} />)
}